import type { AgGridReact } from 'ag-grid-react';
import { type RefObject, useEffect } from 'react';

/**
 * Clears the AG Grid row selection whenever the detail pane closes.
 *
 * The settings grids use `rowSelection: singleRow`, so a clicked row keeps its
 * `ag-row-selected` highlight even after the detail pane is dismissed, leaving a
 * highlighted row with nothing shown beside it. Driving this off `detailOpen`
 * rather than individual close handlers covers every close path — the header
 * close button, the footer cancel button, and programmatic closes after a save
 * or delete.
 */
/** The settings grids hold varying row types; only the grid API is used here. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyGridRef = RefObject<AgGridReact<any> | null>;

export function useGridDeselectOnClose(gridRef: AnyGridRef, detailOpen: boolean): void {
  useEffect(() => {
    if (detailOpen) return;
    const api = gridRef.current?.api;
    if (!api || api.isDestroyed()) return;
    api.deselectAll();
  }, [detailOpen, gridRef]);
}
